import React, { Component } from "react";
import { LocaleContext } from "../Context/Locale";
import Routing from "fos-routing";
import RoutingData from "../../../../public/js/fos_js_routes.json";

Routing.setData(RoutingData);

const withFosRouter = ComposedComponent => {
  class Routable extends Component {
    render() {
      const r = locale => (route, data, absolute, overrideLocale) => {
        if (RoutingData.routes[route]) {
          return Routing.generate(route, data, absolute);
        } else {
          if (overrideLocale) {
            return Routing.generate(
              overrideLocale + "__RG__" + route,
              data,
              absolute
            );
          } else {
            return Routing.generate(locale + "__RG__" + route, data, absolute);
          }
        }
      };
      return (
        <LocaleContext.Consumer>
          {locale => <ComposedComponent {...this.props} r={r(locale)} />}
        </LocaleContext.Consumer>
      );
    }
  }
  return Routable;
};

export default withFosRouter;
